import { render, staticRenderFns } from "./shopProductPage.vue?vue&type=template&id=57bd9205"
import script from "./shopProductPage.vue?vue&type=script&lang=js"
export * from "./shopProductPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports